import {gql} from '@apollo/client'

// Query to get all contact segments
export const GET_CONTACT_SEGMENTS = gql`
  query GetContactSegments {
    contactSegments {
      id
      name
      description
      rules
      contactCount
      createdAt
      updatedAt
    }
  }
`

// Mutation to create a new segment
export const CREATE_CONTACT_SEGMENT = gql`
  mutation CreateContactSegment($name: String!, $description: String, $rules: GenericScalar!) {
    createContactSegment(name: $name, description: $description, rules: $rules) {
      ok
      segment {
        id
        name
        description
        rules
        contactCount
      }
    }
  }
`

// Mutation to update a segment
export const UPDATE_CONTACT_SEGMENT = gql`
  mutation UpdateContactSegment($id: ID!, $name: String, $description: String, $rules: GenericScalar) {
    updateContactSegment(id: $id, name: $name, description: $description, rules: $rules) {
      ok
      segment {
        id
        name
        description
        rules
        contactCount
      }
    }
  }
`

// Mutation to delete a segment
export const DELETE_CONTACT_SEGMENT = gql`
  mutation DeleteContactSegment($id: ID!) {
    deleteContactSegment(id: $id) {
      ok
    }
  }
`
